import React from 'react';
import { type Argument, cs } from '@bbkAdminUtils/css-utils';
import { IndicatorColorsMap } from './indicator-colors';

import './styles/dot.scss';

export type DotIndicatorColor = keyof typeof IndicatorColorsMap;
type Props = {
  dotColor: DotIndicatorColor;
  classes?: Argument;
  [extraProps: string]: any;
};

const DotIndicator: React.FC<Props> = (props) => {
  const { dotColor = 'gray', classes, children, ...extraProps } = props;
  return (
    <div className={cs('dot-indicator', dotColor, classes)} {...extraProps}>
      {children}
    </div>
  );
};

export default DotIndicator;
